
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preguntas-frecuentes",
      function () {
        return require("private-next-pages/preguntas-frecuentes/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preguntas-frecuentes"])
      });
    }
  